import { Component, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs'; 
import { formatNumber, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { VesselsService } from '../../../services/vessels.service';
import { PoolingPortalService } from '../../../services/pooling-portal.service';
import { DistributionDataService } from '../../../services/distributionData.service';
import { FiltersService } from '../../../services/filters.service';
import { StorageService } from '../../../services/storage.service';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { SubpoolService } from '../../../services/subpool.service';
import { FleetList, Filters, VesselDetails } from '../../../interface/fleetList.interface';
import { DropdownConfig } from "snl-complib";
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-stjs-fleet',
  templateUrl: './stjs-fleet.component.html',
  styleUrls: ['./stjs-fleet.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class STJSFleetComponent {

  public ShipForm: UntypedFormGroup;
  public modifiedPoolPoint: UntypedFormGroup;
  public penaltyForm: UntypedFormGroup;
  public editShipForm: UntypedFormGroup;
  public statusForm: UntypedFormGroup;
  public moveShipForm: UntypedFormGroup;
  public editPenaltyForm: UntypedFormGroup;
  public subscription: Subscription;
 
  FleetList: FleetList = {
    isSelected : true,
    searchInput: true,
    iShipDetail: false,
    iNewPoolForm: false,
    iNewShipForm: false,
    iAddPenaltyForm: false,
    iModifyPoolPointForm: false,
    iEditPenaltyForm: false,
    iPenaltyForm:  false,
    iEditShipForm: false,
    iStatusForm: false,
    iCheckBox:true,
    allSelect: false,
    iAddNewSubPool:  false,
    iMoveShip:  false,
    iNotShip:  false,
    moveShipSubmit:  false,
    iConfirmModal:  false,
    isSkelton : false,
    isSkeltonSubpool : false,
    download:true,
    tab: '',
    fleet: '',
    searchText: '',
    szShipName:'',
    sortBy: 'subPool',
    sortValue: 'asc',
    revertAction: '',
    vslNumber: '',
    szShipNumber: '',
    szShipCode:  '',
    szShipOwner: '',
    confirmModalTitle: '',
    confirmModalDescription: '',
    shipOwners: [],
    subpool: [],
    vslClass:[],
    ship: [],
    owners:[],
    subPools:[],
    moveSubPools:[],
    subPoolList:[],
    subPoolVessels:[],
    allSubPoolVessels:[],
    // status: [
    //   { label: "Active", value: '1'},
    //   { label: "Inactive", value: '0'},
    // ],
    status: [
      { id:'1', name:"Active"},
      { id:'0', name:"Inactive"},
    ],
    setting : { showCloseIcon: false, backdropClick: false },
    vessels:[],
    monthNameArray: this._poolingPortalService.getMonthShortNames()
    
  }
 
  filters: Filters  = {
    ship: [],
    status:[],
    shipOwners: [],
    vslClass: [],
    subpool: [],
    vslNumber: [],
  }
  
  shipDetail: VesselDetails[] | any;
  vslClasses: any = [];
  subPools:any = [];
  shipOwners: any = [];
  newFleetlist: any = [];
  fleetStatus:any;
  dropdownConfigNoSearch: DropdownConfig =  {
    showSearchBar: false,
    showActionButtons: false
  }
  
 
  constructor(
    private fb: UntypedFormBuilder,
    private _vesselService: VesselsService,
    private _poolingPortalService: PoolingPortalService,
    private _filterService: FiltersService,
    private _storageService: StorageService,
    private router: Router,
    public datepipe: DatePipe,
    private _subpoolService: SubpoolService,
    private toasterService: ToasterService,
    private _distributionDataService: DistributionDataService
  ) {
  }
  ngOnInit() {
    console.log(this.dropdownConfigNoSearch)
    this.subscription = this._poolingPortalService.fleet$.subscribe(
        fleet => {
          this.FleetList.isSkeltonSubpool = true;
          this.FleetList.isSkelton = true;
          this.FleetList.fleet = fleet;
          this.FleetList.tab = 'all';
          this.FleetList.iNotShip = false;
          this.filters['shipOwners'] = [];
          this.filters['vslClass'] = [];
          this.filters['status'] = ["1"];
          this.filters['vslNumber'] = [];
          this.filters['ship'] = [];
          this.filters['subpool'] = [];
          this.getOwnerList();
          this.createModifiedPoolPointForm();
          this.createEditShipForm();
          this.createMoveShipForm();
          this.getSubPools();
        }
      )
    }


  createModifiedPoolPointForm() {
    this.modifiedPoolPoint = this.fb.group({
      szShipCode: [''],
      szShipName: [''],
      poolPoint: [''],
      effectiveForm: [''],
    });
  }

  get mpp() { return this.modifiedPoolPoint.controls; }

  createEditShipForm() {
    this.editShipForm = this.fb.group({
      szShipCode: [''],
      szShipName: [''],
      subpool: [''],
      szOwner: [''],
      szClass: [''],
    });
  }

  get editShip() { return this.editShipForm.controls; }


  createMoveShipForm() {
    this.moveShipForm = this.fb.group({
      subPool: ['', Validators.required],
    });
  }
  get ms() { return this.moveShipForm.controls; }
  
  getVessels() {
    let formData = { "fleet": this.FleetList.fleet};
    this._vesselService.getVessels(formData)
      .subscribe({
        next: (res) => {
          if (res.data.getVessels.success) {
            this.FleetList.vessels = res.data.getVessels.vessels;
            this.refreshDropdownData();
          }
          else if(res.data.getVessels.message == 'Access denied'){
            this.router.navigate(['distribution'])
            return;
          }
          else if(res.data.getVessels.message == 'No Record Found'){
            this.FleetList.vessels = [];
            this.refreshDropdownData();
          }
        }
      });
  }
  
  getOwnerList() {
    this._distributionDataService.getOwnerList(this.FleetList.fleet)
      .subscribe({
        next: (res:any) => {
          this.FleetList.owners = res.data.getOwnersList.data;
          this.FleetList.owners =  this.FleetList.owners.map((items:any)=>({id:items?.value,name:items.label}))
          console.log(this.FleetList.owners)
          this.FleetList.shipOwners = this._filterService.shipOwners(this.FleetList.vessels,this.filters,  this.FleetList.owners);      
          console.log(this.FleetList.shipOwners)
          this.getVessels();
          this.getSubPoolVessel();
        }
      });
  }

  getSubPools() {
    let formData = { "fleet": this.FleetList.fleet};
    this._subpoolService.getSubPools(formData)
      .subscribe({
        next: (res) => {
          if (res.data?.getSubpoolsList.success) {
            this.FleetList.isSkeltonSubpool = false;
            this.FleetList.subPools = res.data.getSubpoolsList.subpools.map((subpool: any) => subpool.name);
            this.FleetList.subPoolList = res.data.getSubpoolsList.subpools;
            if(this.FleetList.fleet == 'SNAPS'){
              this.FleetList.tab = this.FleetList.subPools[0];
            }
          }
          else{
            this.FleetList.isSkeltonSubpool = false;
            this.FleetList.subPools= [];
            this.FleetList.subPoolList = [];
          }
        }
      });
  }

  getSubPoolVessel(subPool: any = '') {
    let formData = { "subPool": subPool,"fleet": this.FleetList.fleet};
    this._vesselService.getSubpoolVessels(formData)
      .subscribe({
        next: (res: any) => {
          if (res.data.getVessels.success) {
            this.FleetList.isSkelton = false;
            this.FleetList.allSubPoolVessels = res.data.getVessels.vessels;
            this.FleetList.iNotShip = (this.FleetList.allSubPoolVessels.length > 0) ? false : true;
            this.FleetList.subPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
            this.FleetList.subPoolVessels.sort(this.compareValues(this.FleetList.sortBy, this.FleetList.sortValue));
          }
          else{
            this.FleetList.isSkelton = false;
            this.FleetList.iNotShip = true;
            this.FleetList.allSubPoolVessels = [];
            this.FleetList.subPoolVessels = [];
          }
        },
        error: (error) => {
          this.FleetList.isSkelton = false;
          
        }
      });
  }
  onPageTabClick(subPool: any) {
    this.FleetList.iNotShip = false;
    this.FleetList.tab = subPool;
    this.FleetList.allSubPoolVessels = [];
    this.FleetList.subPoolVessels = [];
    this.filters['subpool'] = [];
    subPool = (subPool == 'all') ? '' : subPool;
    if(subPool){
      this.filters['subpool'] = [subPool];
    }
    this.FleetList.isSkelton = true;
    this.getSubPoolVessel(subPool);
    this.getVessels();
    this.filters['vslClass'] = [];
    this.filters['shipOwner'] = [];
    this.filters['vslNumber'] = [];
    this.FleetList.allSelect = false;
    this.refreshDropdownData();
    this.FleetList.isSelected = false;
  }

  public sorting(sortBy: string, sortValue: string) {
    this.FleetList.sortBy = sortBy;
    this.FleetList.sortValue = sortValue;
    this.FleetList.subPoolVessels.sort(this.compareValues(sortBy, sortValue));
  }

  public compareValues(key: any, order = 'asc') {
    return function innerSort(a: any, b: any) {
      let x = a;
      let y = b;
      if (!x.hasOwnProperty(key) || !y.hasOwnProperty(key)) {
        return 0;
      }
      const varA = (typeof x[key] === 'string')
        ? x[key].toUpperCase() : x[key];
      const varB = (typeof b[key] === 'string')
        ? y[key].toUpperCase() : y[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order === 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  public removeRefreshData() {
    let that = this;
    let selectedValue: any = [];
    this.FleetList.subPoolVessels.forEach(function (x: any) {
      if (that.filters['vslNumber'].indexOf(x.vslNumber) >= 0) {
        selectedValue.push(x.vslNumber);
      }
    });
    this.filters['vslNumber'] = selectedValue;

  }

  public resetDropdown(event: any, field: string) {
    this.filters[field] = [];
    this.FleetList.subPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
    this.refreshDropdownData();
    if (this.FleetList.allSelect) {
      this.selectAll()
    }
  }

  public resetAll() {
    this.filters['shipOwners'] = [];
    this.filters['vslClass'] = [];
    this.filters['status'] = ['1'];
    this.filters['ship'] = [];
    this.filters['subpool'] = [];
    this.refreshDropdownData();
    this.FleetList.subPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
    this.FleetList.searchText = '';
    this.FleetList.searchInput = false;
    let that = this;
    setTimeout(function () {
      that.FleetList.searchInput = true;
    }, 1);
    if (this.FleetList.allSelect) {
      this.selectAll()
    }
    this.vslClasses = [];
    this.subPools = [];
    this.shipOwners = [];
  }

  public resetActivate() {
    if(this.FleetList.tab == 'all'){
      return (this.filters['shipOwners'].length > 0 || this.filters['subpool'].length > 0 || this.filters['vslClass'].length > 0 || (this.filters['status'].length > 0 && this.filters['status'].includes('0')  )|| this.filters['ship'].length) ? true : false;
    }
    else{
      return (this.filters['shipOwners'].length > 0 || this.filters['vslClass'].length > 0 || (this.filters['status'].length > 0 && this.filters['status'].includes('0')) || this.filters['ship'].length) ? true : false;
    }
  }

  public refreshDropdownData() {
    if(this.FleetList.owners?.length){
      if(this.filters.ship['selectedRecords']?.length){
        this.filters.ship = this.filters.ship['selectedRecords'].map((record: any) => record.name);
        console.log(this.filters.ship)
      }
      if(this.filters.shipOwners['selectedRecords']?.length){
        this.filters.shipOwners = this.filters.shipOwners['selectedRecords'].map((record: any) => record.id);
        console.log("this.filters.shipOwners",this.filters.shipOwners)
      }
       console.log("this.FleetList.owners",this.FleetList.owners )

      this.FleetList.shipOwners = this._filterService.shipOwners(this.FleetList.vessels,this.filters,this.FleetList.owners);
      console.log("this.FleetList.shipOwners2",this.FleetList.shipOwners )
      this.FleetList.shipOwners = this.FleetList.shipOwners.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
      console.log(this.FleetList.shipOwners)
      // this.newFleetlist =  this.FleetList.shipOwners.map((items:any)=>({id:items?.id,name:items.name}))
      // console.log(this.newFleetlist)
    }
    if(this.filters.subpool['selectedRecords']?.length){
      this.filters.subpool = this.filters.subpool['selectedRecords'].map((record: any) => record.name);
    }
     console.log("this.filters.subpool",this.filters.subpool)
    this.FleetList.ship = this._filterService.ships(this.FleetList.vessels, this.filters);
    // this.FleetList.shipOwners = this._filterService.shipOwners(this.FleetList.vessels, this.filters,this.FleetList.owners);
    this.FleetList.vslClass = this._filterService.vslClass(this.FleetList.vessels, this.filters);
    this.FleetList.vslClass =  this.FleetList.vslClass.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
    this.FleetList.subpool = this._filterService.subpools(this.FleetList.vessels, this.filters);
    this.FleetList.subpool =  this.FleetList.subpool.filter((obj:any, index:any, self:any) => index === self.findIndex((x:any) => x.id === obj.id));
    console.log(this.FleetList.status);
    this.fleetStatus = this.FleetList.status.filter((items:any)=>items.id === '1');
    console.log(this.fleetStatus)
    console.log(this.FleetList.ship)
   
  }
  public selectedValues(event: any, field: string) {
    // this.filters[field] = event;
    this.filters[field] = event.selectedRecords?.map((items:any) =>items?.id);
    console.log("this.filters[field]",this.filters[field])
    this.FleetList.subPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
    this.refreshDropdownData();
    this.removeRefreshData();
    if (this.FleetList.allSelect) {
      this.selectAll()
    }
     if(field === 'vslClass'){
      this.vslClasses =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
      console.log("store1",this.vslClasses)
    }else if(field === 'subpool'){
      this.subPools =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
      console.log("store2",this.subPools)
    } else if(field === 'shipOwners'){
      this.shipOwners =  this.filters[field]?.map((items:any) =>({id:items,name:items}))
      console.log("store3",this.shipOwners)
    }else if(field === 'status'){
       this.fleetStatus = this.filters[field]?.map((items:any) =>({id:items,name:items}))
        console.log("store4",this.fleetStatus)
    }
  }
  valuechange(value: any) {
    console.log(value)
    if (value) {
      this.filters['ship'][0] = value;
    }
    else {
      this.filters['ship'] = [];
    }
    this.refreshDropdownData();
    this.FleetList.subPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
    if (this.FleetList.allSelect) {
      this.selectAll()
    }
  }

  public selectVessel(vessel: string) {
    let index = this.filters['vslNumber'].indexOf(vessel);
    if (!this.filters['vslNumber'].includes(vessel)) {
      this.filters['vslNumber'].push(vessel);
    }
    else {
      this.filters['vslNumber'].splice(index, 1);
    }

  }

  public clearSection() {
    this.filters['vslNumber'] = [];
    this.FleetList.allSelect = false;
  }

  public selectAll() {
    let stjsintermediate:boolean =  this.stjsintermediate()
    this.filters['vslNumber'] = [];
    if(!stjsintermediate && !this.FleetList.allSelect){
      this.FleetList.allSelect = true;
    }
    else{
      this.FleetList.allSelect = false;
    }
    if (this.FleetList.allSelect && !stjsintermediate) {
      let allSubPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
      allSubPoolVessels.forEach((it: any) => {
        this.filters['vslNumber'].push(it.vslNumber);
      });
    }
  }

  public allSelectClick() {
    this.filters['vslNumber'] = [];
    this.FleetList.allSelect = true;
    let allSubPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
      allSubPoolVessels.forEach((it: any) => {
        this.filters['vslNumber'].push(it.vslNumber);
      });
      this.FleetList.iCheckBox = false;
      setTimeout(() => {
        this.FleetList.iCheckBox = true;
    }, 1);
  }

  addNewShipFrom() {
    this.FleetList.iNewShipForm = true;
  }

  shipAction(action: any, shipDetail: any) {
    this.shipDetail = shipDetail;
    this.FleetList.vslNumber = shipDetail.vslNumber;

    switch (action) {
      case 'modify_pool_point':
        this.FleetList.iModifyPoolPointForm = true;
        this.createModifiedPoolPointForm();
        break;

      case 'add_penalty':
        this.FleetList.iPenaltyForm = true;
        this.FleetList.iAddPenaltyForm = true;
        this.FleetList.iEditPenaltyForm = false;
        break;

      case 'edit_penalty':
        this.FleetList.iPenaltyForm = true;
        this.FleetList.iEditPenaltyForm = true;
        this.FleetList.iAddPenaltyForm = false;
        break;

      case 'edit_ship':
        this.FleetList.iEditShipForm = true;
        break;

      case 'status':
        this.FleetList.iStatusForm = true;
        break;

      case 'revert_poolpoint':
        this.FleetList.confirmModalTitle = "Revert to Nominal Pool Points";
        this.FleetList.revertAction = "pool_point";
        this.FleetList.iConfirmModal = true;
        break;

      case 'revert_penalty':
        this.FleetList.confirmModalTitle = "Revert Penalty Changes";
        this.FleetList.revertAction = "penalty";
        this.FleetList.iConfirmModal = true;
        break;

      case 'revert_close_penalty':
        this.FleetList.confirmModalTitle = "Revert Close Penalty Changes";
        this.FleetList.revertAction = "closepenalty";
        this.FleetList.iConfirmModal = true;
        break;

      case 'revert_status':
        this.FleetList.confirmModalTitle = `Revert to ${shipDetail.updatedStatus == 'active' ? 'Inactive' : 'Active'} Status`;
        this.FleetList.revertAction = "status";
        this.FleetList.iConfirmModal = true;
        break;

        case 'delete_ship':
        this.FleetList.confirmModalTitle = "Revert Activation & Delete Ship";
        this.FleetList.confirmModalDescription = "The action will be reverted and chosen ship will be deleted from "+ this.FleetList.fleet +" Fleet";
        this.FleetList.revertAction = "delete";
        this.FleetList.iConfirmModal = true;
        break;

      default:
        break;
    }
  }

  createPdf() {
    let doc = new jsPDF('p', 'mm', [210, 297]);
    let y = 10;
    doc.setLineWidth(1);
    doc.setFontSize(13);
    doc.text(this.FleetList.fleet + " - Fleet", 100, y);
    doc.setFontSize(10);
    if (this.FleetList.tab != 'all') {
      doc.text("Sub Pool : " + this.FleetList.tab, 15, y + 5);
    }
    doc.setFont("Roboto");
    console.log(this.filters);
    let downloadData = this._filterService.stjsfilterItemsDownload(this.FleetList.allSubPoolVessels, this.filters);
    downloadData.sort(this.compareValues(this.FleetList.sortBy, this.FleetList.sortValue));
    let data: any = []
    downloadData.forEach((subPoolVessel: any) => {
      let valueArray = [subPoolVessel.vslName];
      if(this.FleetList.tab == 'all'){
        valueArray.push(subPoolVessel.subPool)
      }
      valueArray.push(subPoolVessel.vslClass,this._poolingPortalService.getVslOwnerLabel(subPoolVessel.vslOwner,this.FleetList.owners),subPoolVessel.fleet);
      if(this.FleetList.fleet != 'SNAPS'){
        valueArray.push((subPoolVessel.scbrPoints) ? formatNumber(subPoolVessel.scbrPoints, 'en', '1.1-1'): '-');
      }
      valueArray.push(formatNumber(subPoolVessel.poolPoint, 'en', '1.2-2'))
      data.push(valueArray);
    });

    let columnStyles: any = { 0: { cellWidth: 60 }, 4: { halign: 'right' }, 5: { halign: 'right' } }
    let head:any = [];
    head.push('Ship');
    if ((this.FleetList.tab == 'all')) {
      head.push('Sub Pool');
      columnStyles = { 0: { cellWidth: 60 }, 5: { halign: 'right' }, 6: { halign: 'right' } }
    }
    head.push('Class', 'Ship Owner', 'Fleet')
    if(this.FleetList.fleet !='SNAPS'){
      head.push('Scrubber Points');
    }
    head.push('Pool Points');
    autoTable(doc, {
      body: data,
      startY: 20,
      theme: 'grid',
      head: [head],
      headStyles: { lineWidth: 0.3, fillColor: [211, 211, 211], textColor: '#27364B' },
      styles: { halign: 'center', fontSize: 9 },
      columnStyles: columnStyles,
    })
    let filename = this.FleetList.monthNameArray[Number(new Date().getMonth())].toUpperCase() + '-' + new Date().getFullYear().toString().slice(-2) + '_'+ this.FleetList.fleet +'.pdf'
    if(this.FleetList.download){
      doc.save(filename);
    }
    return filename;

  }

  createXlxs() {
    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Sheet1');
    let columns:any = [{ header: 'Ship', key: '', width: 40 }];
    if ((this.FleetList.tab == 'all')) {
        columns.push({ header: 'Sub Pool', key: '', width: 20 })
    }
    columns.push(
      { header: 'Class', key: '', width: 20 },
      { header: 'Ship Owner', key: '', width: 20 },
      { header: 'Fleet', key: '', width: 20 },
    )
    if ((this.FleetList.fleet != 'SNAPS')) {
      columns.push({ header: 'Scrubber Points', key: '', width: 20 })
    }
    columns.push({ header: 'Pool Points', key: '', width: 15 })
    worksheet.columns = columns;
    let downloadData = this._filterService.stjsfilterItemsDownload(this.FleetList.allSubPoolVessels, this.filters);
    downloadData.sort(this.compareValues(this.FleetList.sortBy, this.FleetList.sortValue));
    downloadData.forEach((subPoolVessel: any) => {
      let data = [subPoolVessel.vslName];
      if(this.FleetList.tab == 'all'){
        data.push(subPoolVessel.subPool)
      }
      data.push(subPoolVessel.vslClass,this._poolingPortalService.getVslOwnerLabel(subPoolVessel.vslOwner,this.FleetList.owners),subPoolVessel.fleet);
      if(this.FleetList.fleet != 'SNAPS'){
        data.push((subPoolVessel.scbrPoints) ? Number(subPoolVessel.scbrPoints): '-');
      }
      data.push(Number(subPoolVessel.poolPoint))
      let row = worksheet.addRow(data, 'n');
      row.eachCell(function(cell, colNumber) {
        if((colNumber == 5 || colNumber == 6 || colNumber == 7)){
          cell.style = { numFmt : "#,##0.0"};
        }
      })

    });
    let filename = this.FleetList.monthNameArray[Number(new Date().getMonth())].toUpperCase() + '-' + new Date().getFullYear().toString().slice(-2) + '_'+ this.FleetList.fleet +'.xlsx'
    worksheet.getRow(1).font = { bold: true, size: 12 };
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      if(this.FleetList.download){
        saveAs(blob, filename, { autoBom: false });
      }
    })
    return filename;
  }

  public checkBox(vslNumber: string) {
   if (this.filters['vslNumber'].includes(vslNumber) || this.FleetList.allSelect) {
      return true;
    }
    else {
      return false;
    }
  }

  public moveShip() {
    this.FleetList.iMoveShip = true;
    this.FleetList.moveSubPools = [...this.FleetList.subPools];
    if(this.FleetList.tab != 'all'){
      const index = this.FleetList.moveSubPools.indexOf(this.FleetList.tab);
      if (index > -1) {
        this.FleetList.moveSubPools.splice(index, 1); 
      }
    }
  }

  closeShip(event: any) {
    this.FleetList.iNewShipForm = false;
    if (this._storageService.getDataFromStorage("listReloadAction") == "yes") {
      this.onPageTabClick(event);
      this._storageService.removeDataFromStorage("listReloadAction");
    }

  }

  getDateAsStringPattern(date: Date | null = null) {
    date = date || new Date();
    let dateNew = new Date(date);
    let day = dateNew.getDate();
    let month = dateNew.getMonth() + 1;
    let year = dateNew.getFullYear();
    return `${String(year)}-${(month < 10) ? ('0' + month) : String(month)}-${(day < 10) ? ('0' + day) : String(day)}`;
  }

  rowClick(event, vessel) {
    if (event) {
      this.FleetList.iShipDetail = true;
      this.shipDetail = vessel;
      this.FleetList.vslNumber = vessel.vslNumber;
    }
  }

  closeShipDetail(event: any) {
    this.FleetList.iShipDetail = false;
    this.FleetList.vslNumber = '';
    if (event) {
      this.onPageTabClick(this.FleetList.tab);
    }
  }

  public closeMarkAsStatus(event) {
    this.FleetList.iStatusForm = false;
    if (!this.FleetList.iShipDetail) {
      this.refreshBody();
    }
  }

  public closeEditShip(event) {
    this.FleetList.iEditShipForm = false;
    if (!this.FleetList.iShipDetail) {
      this.refreshBody();
    }
  }

  public closePenality(event) {
    this.FleetList.iPenaltyForm = false;
    this.FleetList.iAddPenaltyForm = false;
    this.FleetList.iEditPenaltyForm = false;
    if (!this.FleetList.iShipDetail) {
      this.refreshBody();
    }
  }

  refreshSubpool(event) {
    this.getSubPools();
  }
  refreshBody() {
    if (this._storageService.getDataFromStorage("listReloadAction") == "yes") {
      this.onPageTabClick(this.FleetList.tab);
      this._storageService.removeDataFromStorage("listReloadAction");
    }
  }
  moveShipToSubpool() {
    this.FleetList.moveShipSubmit = true;
    let moveShipData = this._filterService.stjsfilterItemsDownload(this.FleetList.allSubPoolVessels, this.filters);
    let shipNumbers = moveShipData.map((x) => x.vslNumber);
    if (this.moveShipForm.invalid) {
      return;
    }
    this._subpoolService.moveShipsOfSubpool(shipNumbers, this.moveShipForm.value.subPool)
      .subscribe({
        next: (res: any) => {
          const response = res.data.updateSubPoolOfVessels;
          if (response.success) {
            this.closeShipToSubpool();
            this.toasterService.openToast('Success', response.message);
            this.onPageTabClick(this.FleetList.tab);
            this.createMoveShipForm();
            this.FleetList.moveShipSubmit = false;
          }
        },
        error: (error) => {
          console.log(error);
        }
      });

  }

  onAction(status: boolean) {
    this.FleetList.iConfirmModal = false;
    if (status) {
      switch (this.FleetList.revertAction) {
        case "pool_point":
          this.revertPoolPoints();
          break;
        case "penalty":
          this.revertPenalty();
          break;
        case "closepenalty":
          this.revertClosePenalty();
          break;
        case "status":
          this.revertStatus();
          break;
        case "delete":
          this.deleteShip();
          break;

        default:
          break;
      }
    }
    this.FleetList.revertAction = "";
  }

  revertPoolPoints() {
    this._vesselService.revertPoolPoints(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertPoolPoints.success) {
            this.onPageTabClick(this.FleetList.tab);
            this.toasterService.openToast('Success', res.data.revertPoolPoints.message);
          }
        }
        
      });
  }

  revertPenalty() {
    this._vesselService.revertPenalty(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertPenalty.success) {
            this.onPageTabClick(this.FleetList.tab);
            this.toasterService.openToast('Success', res.data.revertPenalty.message);
          }
        }
      });
  }

  revertClosePenalty() {
    this._vesselService.revertClosePenalty(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertClosePenalty.success) {
            this.onPageTabClick(this.FleetList.tab);
            this.toasterService.openToast('Success', res.data.revertClosePenalty.message);
          }
        }
      });
  }

  revertStatus() {
    this._vesselService.revertStatus(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertStatus.success) {
            this.onPageTabClick(this.FleetList.tab);
            this.toasterService.openToast('Success', res.data.revertStatus.message);
          }
        }
      });
  }

  deleteShip()
  {
    this._vesselService.deleteVessel(this.FleetList.vslNumber)
      .subscribe({
        next: (res) => {
            if (res.data.deleteVessel.success){
              this.onPageTabClick(this.FleetList.tab);
              this.toasterService.openToast('Success', res.data.deleteVessel.message);
            }
        }
    });
  }

  checkEffectiveDate(effectiveDate: string, effectiveTime: string = '') {
    let effectiveDateUTCNumber;
    if (effectiveTime && effectiveTime != "" && effectiveTime != null) {
      let hours = Number(effectiveTime.split(":")[0]);
      let minutes = Number(effectiveTime.split(":")[1]);
      effectiveDateUTCNumber = new Date(effectiveDate).setUTCHours(hours, minutes, 0, 0);
    } else {
      effectiveDateUTCNumber = new Date(effectiveDate).setUTCHours(0, 0, 0, 0);
    }
    let todayUTCNumber = new Date(new Date().toUTCString()).getTime();
    return (effectiveDateUTCNumber <= todayUTCNumber) ? true : false;
  }

  closeShipToSubpool(){
    this.FleetList.iMoveShip = false;
    document.body.style.overflow = "auto";
  }
  public stjsintermediate(){
    let allSubPoolVessels = this._filterService.stjsfilter(this.FleetList.allSubPoolVessels, this.filters);
    if(this.filters['vslNumber'].length === 0 || (allSubPoolVessels.length == this.filters['vslNumber'].length)){
        return false;
    }
    return true;
  }

  public rowActive(vslNumber){
    if(vslNumber == this.FleetList.vslNumber){
       return true;
    }
    return false;
  }

  

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}


